import { UserCreatePage } from '@pages/user';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Создание пользователя', 'Создание нового пользователя');
}

export default UserCreatePage;
